import React from "react";

import { WatchVec2 } from "@piqnt/runtime-core/react/WatchValue";

import {
  useMiddleware,
  EmitFunction,
} from "@piqnt/runtime-core/react/ReactMount";
import { OutlineContext } from "./OutlineContext";

import { getLabel } from "@piqnt/runtime-core/common/Label";
import { getKey } from "@piqnt/runtime-core/common/Key";
import { Body } from "planck";

interface LiveBodyProps {
  emit: EmitFunction;
  body: Body;
  selected: boolean;
  selectable?: boolean;
  variant?: "short";
}

class LiveBodyComponent extends React.PureComponent<LiveBodyProps> {
  handleClick = () => {
    const { emit, body } = this.props;
    emit("select-body", { body: getKey(body) });
  };

  render() {
    const { body, selected, selectable, variant } = this.props;
    if (!body) {
      return null;
    }
    const label = getLabel(body);

    let showType: boolean;
    let showPosition: boolean;

    if (variant === "short") {
      showType = false;
      showPosition = !label;
    } else {
      showType = true;
      showPosition = true;
    }

    let className = "";
    className += selected ? "selected-item " : "";
    className += selectable ? "clickable " : "";
    return (
      <span
        className={className}
        onClick={selectable ? this.handleClick : null}
      >
        {label ? "body#" + label : showType && body.getType()}{" "}
        {showPosition && <WatchVec2 getValue={() => body.getPosition()} />}
      </span>
    );
  }
}

interface LiveBodyComponentProps {
  body: Body;
  selectable?: boolean;
  variant?: "short";
}

export const LiveBody = (props: LiveBodyComponentProps) => {
  const { context, emit } = useMiddleware<OutlineContext>();
  const bodyKey = getKey(props.body);
  const selected = !!context.multiselect?.value.findKey(bodyKey);

  return (
    <LiveBodyComponent
      body={props.body}
      selectable={props.selectable}
      variant={props.variant}
      emit={emit}
      selected={selected}
    />
  );
};
